<ion-header class="header --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.home" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <span [innerHTML]="'INTEGRATIONS.BREADCRUMB_NAME' | translate"></span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="integrations__section">
    <div class="integrations__section__cards">
      <div class="integrations__section__cards__item" [routerLink]="[routes.googleReviews]">
        <div class="integrations__section__cards__item__card">
          <ion-img src="/assets/integrations/google-reviews.png"></ion-img>
          <ion-icon name="settings-outline"></ion-icon>
        </div>
        <ion-text class="integrations__section__cards__item__name" [innerHTML]="'GOOGLE_REVIEWS.BREADCRUMB_NAME' | translate"></ion-text>
      </div>

      <div class="integrations__section__cards__item --is-suggestion" (click)="suggestIntegration()">
        <div class="integrations__section__cards__item__card">
          <ion-text [innerHTML]="'INTEGRATIONS.SUGGEST_YOURS' | translate"></ion-text>
        </div>
      </div>
    </div>
  </div>
</ion-content>
